import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const codeServerWeb: PluginWebManifest = {
  // code-server is a no-page plugin — it only contributes an agent
  // action button, not a top-level nav entry. We still emit an
  // overview card by hand (rather than reaching for `definePage`,
  // which would mint an unwanted route/nav-item/command) so the
  // plugin detail page renders an "About this plugin" section with
  // the same details + features the marketing surfaces use. The card
  // `to` targets the canonical plugin detail page since there is no
  // standalone page to deep-link to.
  overviewCards: [
    {
      to: '/org/plugins/code-server',
      label: 'Code Server',
      icon: 'Code',
      description: 'Browser-based VS Code inside every agent devbox.',
      details:
        "Spawns a code-server (browser-based VS Code) instance inside each agent's devbox so you can inspect, edit, and run code in the agent's workspace directly from your browser — no SSH, no local checkout, no syncing.",
      features: [
        '"Open Editor" agent action in the agent header',
        'Browser-based VS Code, no local install required',
        'Per-agent isolated editor session',
        'Reads and writes the live devbox filesystem',
        'Terminal, debugger, and extensions all run alongside the agent',
      ],
      group: 'plugins',
    },
  ],
  agentActions: [
    {
      label: 'Open Editor',
      icon: 'Code',
      componentPath: '@reflex/plugin-code-server/web/OpenEditorButton',
      category: 'environment',
      hideOnMobile: true,
    },
  ],
};
